import { render } from "./MessageSender.vue?vue&type=template&id=41f6a3f2&scoped=true"
import script from "./MessageSender.vue?vue&type=script&lang=js"
export * from "./MessageSender.vue?vue&type=script&lang=js"

import "@/assets/styles.css?vue&type=style&index=0&lang=css&external"
import "./MessageSender.vue?vue&type=style&index=1&id=41f6a3f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f6a3f2"]])

export default __exports__